export default "__VITE_ASSET__h4y4Snoc__"